export default __webpack_public_path__ + "static/media/Delta_ClearanceSpecials_WebBanner_CategoryCover_V2.afd6966f.jpg";